"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var iconStyleMixin = exports.iconStyleMixin = function iconStyleMixin(color) {
  return "\n  color: " + color + ";\n  border-color: currentColor;\n  \n  svg { fill: currentColor; }\n";
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-icons/dist/iconStyleMixin.js
// module id = 723
// module chunks = 0